import { createI18n } from "vue-i18n";
// import translations
import ru from "../assets/na-lang-ru.json";
import en from "../assets/na-lang-en.json";
import vi from "../assets/na-lang-vi.json";

// configure i18n
export const i18n = createI18n({
    locale: "en",
    fallbackLocale: "en",
    messages: { ru, en, vi },
});